import { Breadcrumbs } from '@uhg-abyss/web/ui/Breadcrumbs';
import { FindhelpCategory, UniteUsService } from '@src/api.types';
import React from 'react';

export type CboSearchCategoryBreadcrumbsProps = {
  breadcrumbTrail: any[];
  onClickCrumb: (catName: any, catId: any) => void;
};

export type CategoryDataNode = {
  id: string;
  label: string;
  children?: CategoryDataNode[];
};

export function uniteusCatsToGeneric(
  category: UniteUsService
): CategoryDataNode {
  return {
    id: category.id,
    label: category.label,
    children: category.children?.map(uniteusCatsToGeneric),
  };
}

export function findhelpCatsToGeneric(
  category: FindhelpCategory
): CategoryDataNode {
  return {
    id: String(category.id),
    label: category.label,
    children: category.children?.map(findhelpCatsToGeneric),
  };
}


interface BreadcrumbItem {
  label: string;
  id: string | null;
}

export function getBreadcrumbTrail(
  categorySearchTerm: string | number | undefined,
  categoryData: CategoryDataNode[]
): BreadcrumbItem[] {
  if (categorySearchTerm === undefined || categorySearchTerm === null) {
    return [{ label: "Unknown Category", id: null }];
  }

  function evaluateMatch(
    searchTerm: string | number,
    category: CategoryDataNode
  ): boolean {
    const searchStr = String(searchTerm).toLocaleLowerCase();
    return (
      category.id.toLocaleLowerCase() === searchStr ||
      category.label.toLocaleLowerCase() === searchStr
    );
  }

  function findPath(
    searchTerm: string | number,
    categories: CategoryDataNode[],
    path: BreadcrumbItem[] = []
  ): BreadcrumbItem[] | null {
    for (const category of categories) {
      const newPath = [...path, { label: category.label, id: category.id }];
      if (evaluateMatch(searchTerm, category)) {
        return newPath;
      }
      if (category.children) {
        const result = findPath(searchTerm, category.children, newPath);
        if (result) return result;
      }
    }
    return null;
  }
  const path = findPath(categorySearchTerm, categoryData);
  return path || [{ label: String(categorySearchTerm), id: null }];
}


export function CboSearchCategoryBreadcrumbs({
  breadcrumbTrail,
  onClickCrumb,
}: CboSearchCategoryBreadcrumbsProps): React.JSX.Element {
const getcatID = (name: string, breadcrumbTrail: { label: string; id: string | null }[]): string | null => {
  const match = breadcrumbTrail?.find((bd) => bd?.label === name);
  return match?.id ?? null;
};


  return (
    <div className="cbo-breadcrumbs-wrapper" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
      <style>{`
        .cbo-breadcrumbs-wrapper a,
        .cbo-breadcrumbs-wrapper li span { font-size: 1.1rem !important; }
        .cbo-breadcrumbs-wrapper .abyss-breadcrumb-current { font-weight: bold; }
      `}</style>
    <Breadcrumbs
      onClick={(event, item) => {
        event.preventDefault();
        event.stopPropagation();
        onClickCrumb(item.title, getcatID(item.title,breadcrumbTrail));
      }}

      items={breadcrumbTrail.map((crumb: any) => {
        return {
          title: crumb.label,
          id: crumb.id,
          // NOTE - I tried to just have this be "/search",
          // but that prevented any breadcrumbs from being
          // shown for some reason.

          // We are not gonna use this href regardless,
          // instead using an onClick handler to control
          // the behavior.
          href: '/',
          isLink: true,
        };
      })}
    />
    </div>
  );
}
